<template>
	<div>
		<form @submit.prevent="updateStaticSearch()">
			<div class="row g-2">
				<div class="col-sm-7 col-md-7 col-lg-8 col-xl-9">
					<div class="form-group form-static-search">
						<input
							type="text"
							v-model="model"
							class="form-control"
							placeholder="Hier Wunschkriterien eintippen"
							aria-label="Suche nach Wunschkriterien"
							aria-describedby="button-addon2"
						/>
						<button
							v-if="model !== ''"
							class="btn btn-link btn-delete"
							title="Eingabe löschen"
							type="button"
							@click="deleteStaticSearch()"
						>
							<i class="mdi mdi-close-thick text-danger"></i>
						</button>
					</div>
				</div>
				<div class="col-sm-5 col-md-5 col-lg-4 col-xl-3">
					<button
						class="btn btn-block"
						:class="btnDark ? 'btn-dark' : 'btn-white'"
						type="submit"
					>
						Jetzt suchen <i class="mdi mdi-magnify"></i>
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import store from '@/store'
import { required } from '@vuelidate/validators'

export default {
	name: 'FormTextSearch',
	data() {
		return {
			model: '',
		}
	},
	props: {
		btnDark: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	methods: {
		updateStaticSearch() {
			if (this.model !== '') {
				store.commit('updateSearch', this.model)
				this.$emit('updateFilter')
			}
		},
		deleteStaticSearch() {
			this.model = ''
			if (store.state.search) {
				store.commit('updateSearch', '')
				this.$emit('updateFilter')
			}
		},
	},
	created() {
		if (store.state.search) {
			this.model = store.state.search
		}
		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'updateSearch' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (state.search === '' && this.model !== '') {
					this.model = ''
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>

<style lang="scss" scoped>
.form-static-search {
	position: relative;
	> input {
		&:focus {
			border-color: $gray-600;
		}
	}
}
.btn-delete {
	z-index: 50;
	position: absolute;
	top: 0;
	right: -8px;
	transition: all 0.25s;
	i {
		font-size: $px18;
	}
	&:hover {
		transform: scale(1.5);
	}
}
</style>
